<div class="interaction-bar-wrapper reporting-bar">
  <div class="interaction-bar-title default-cursor">
    @if (currentPage > 0) {
      <app-back-button-box (clicked)="decrementPage()" class="text-initial"></app-back-button-box>
    }
    <span [ngClass]="{ 'shift-left': currentPage > 0 }">Print Invoice Log:</span>
    @if (currentPage === PROPERTY_PAGE) {
      <span class="font-normal ml-1">Select Properties</span>
    }
    @if (currentPage === PROJECTS_PAGE) {
      <span class="font-normal ml-1">Select Projects</span>
    }
    @if (currentPage === SP_PAGE) {
      <span class="font-normal ml-1">Select Service Providers</span>
    }
    @if (currentPage === DATES_PAGE) {
      <span class="font-normal ml-1">Select Date Ranges</span>
    }
  </div>

  @if (isLoading) {
    <app-loading-spinner class="contents"></app-loading-spinner>
  }

  @if (!isLoading) {
    <div class="interaction-bar-content" [formGroup]="reportFields">
      @if (currentPage === PROPERTY_PAGE) {
        <div class="page">
          <app-floating-input
            placeholder="Search"
            label="Search"
            name="property_search"
            [(ngModel)]="propertySearch"
            (iconClick)="onPropertyIconClick()"
            (ngModelChange)="propertySearchChanged($event)"
            [iconClass]="
              propertySearch
                ? 'icon-add rotate-45 text-navy-500 cursor-pointer hover:text-red-500'
                : 'icon-search text-navy-500'
            "
          ></app-floating-input>
          <ng-scrollbar appearance="native" orientation="vertical" class="std-scrollbar reporting-scroll">
            @if (propertiesToList.length === 0) {
              <div class="text-navy-600 text-center px-2 py-5">
                There are no properties corresponding to the search.
              </div>
            }
            @if (!propertySearch && propertiesToList.length > 0) {
              <div (click)="toggleAllValues('property_ids', allPropertyIds)" class="checklist-item">
                <app-checklist-item
                  title="All Properties"
                  [checked]="isAllSelected['property_ids']"
                ></app-checklist-item>
              </div>
            }
            @for (property of propertiesToList; track property) {
              <div (click)="toggleProperty(property.id)" class="checklist-item">
                <app-checklist-item
                  [title]="property.name"
                  [subtitle]="property.formatted_address"
                  [checked]="reportFields.get('property_ids').value.includes(property.id)"
                ></app-checklist-item>
              </div>
            }
          </ng-scrollbar>
        </div>
      }
      @if (currentPage === PROJECTS_PAGE) {
        <div class="page">
          <app-floating-input
            placeholder="Search"
            label="Search"
            name="project_search"
            [(ngModel)]="projectSearch"
            (iconClick)="onProjectIconClick()"
            [iconClass]="
              projectSearch
                ? 'icon-add rotate-45 text-navy-500 cursor-pointer hover:text-red-500'
                : 'icon-search text-navy-500'
            "
          ></app-floating-input>
          <ng-scrollbar appearance="native" orientation="vertical" class="std-scrollbar reporting-scroll">
            @if (filteredProjects.length === 0) {
              <div class="text-navy-600 text-center px-2 py-5">
                There are no projects corresponding to the selected years, properties or search.
              </div>
            }
            @if (!projectSearch && filteredProjects.length > 0) {
              <div (click)="toggleAllValues('project_ids', filteredProjectIdsWithoutSearchTerm)" class="checklist-item">
                <app-checklist-item title="All Projects" [checked]="isAllSelected['project_ids']"></app-checklist-item>
              </div>
            }
            @for (project of filteredProjects; track project) {
              <div (click)="toggleProject(project.id)" class="checklist-item">
                <app-checklist-item
                  [title]="project.title"
                  [subtitle]="project?.project_property?.formatted_address ?? ''"
                  [checked]="reportFields.get('project_ids').value.includes(project.id)"
                ></app-checklist-item>
              </div>
            }
          </ng-scrollbar>
        </div>
      }
      @if (currentPage === SP_PAGE) {
        <div class="page">
          <app-floating-input
            placeholder="Search for a company..."
            label="Search"
            name="companies_search"
            [(ngModel)]="serviceProviderSearch"
            (iconClick)="onCompanyIconClick()"
            [iconClass]="
              serviceProviderSearch
                ? 'icon-add rotate-45 text-navy-500 cursor-pointer hover:text-red-500'
                : 'icon-search text-navy-500'
            "
          ></app-floating-input>
          <ng-scrollbar appearance="native" orientation="vertical" class="std-scrollbar reporting-scroll">
            @if (filteredServiceProvidersList.length === 0) {
              <div class="text-navy-600 text-center px-2 py-5">
                There are no companies corresponding to your search.
              </div>
            }
            @if (!serviceProviderSearch && serviceProvidersList.length > 0) {
              <div (click)="toggleAllSP()" class="checklist-item">
                <app-checklist-item
                  title="All Companies"
                  [checked]="isAllSelected['service_provider_ids']"
                ></app-checklist-item>
              </div>
            }
            @for (serviceProvider of filteredServiceProvidersList; track serviceProvider) {
              <div (click)="toggleSP(serviceProvider.id)" class="checklist-item">
                <app-checklist-item
                  [title]="serviceProvider.name"
                  [checked]="reportFields.get('service_provider_ids').value.includes(serviceProvider.id)"
                ></app-checklist-item>
                <!--            [subtitle]="company?.project_property?.formatted_address ?? ''"-->
              </div>
            }
          </ng-scrollbar>
        </div>
      }
      @if (currentPage === DATES_PAGE) {
        <div class="page">
          <form #dateRangesPageForm="ngForm" role="form" class="flex gap-4 items-center">
            <app-input-calendar
              name="invoice_log_start_date"
              class="flex-1"
              [(date)]="dateRanges.invoice_log_start_date"
              [maxDate]="dateRanges.invoice_log_end_date"
              (dateChange)="checkDatesValidation()"
              [showIcon]="true"
              [required]="true"
              [disabled]="false"
              placeholder="Start Date"
            ></app-input-calendar>
            <app-input-calendar
              name="invoice_log_end_date"
              class="flex-1"
              [(date)]="dateRanges.invoice_log_end_date"
              [minStartDate]="dateRanges.invoice_log_start_date"
              (dateChange)="checkDatesValidation()"
              [showIcon]="true"
              [required]="true"
              [disabled]="false"
              placeholder="End Date"
            ></app-input-calendar>
          </form>
        </div>
      }
      <div class="text-red-500 text-center my-2">
        {{ errorMessage }}
      </div>
      @if (currentPage < MAX_PAGE) {
        <button
          (click)="incrementPage()"
          [disabled]="nextDisabled"
          [ngClass]="{ disabled: nextDisabled }"
          class="btn next-btn"
          mat-button
        >
          @if (!isLoading) {
            <span>Next</span>
          }
          @if (isLoading) {
            <span class="icon-refresh animate-spin"></span>
          }
        </button>
      } @else {
        <button
          (click)="fillFormAndSubmit()"
          [ngClass]="{ disabled: submitDisabled }"
          [disabled]="submitDisabled"
          class="btn"
          mat-button
        >
          <span>Generate report</span>
        </button>
      }
    </div>
  }
</div>
